var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_5032_48457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06191 19.8144C8.4571 19.8144 15.5184 12.2698 15.5184 8.15175C15.5184 4.03367 12.18 0.695312 8.06191 0.695312C3.94383 0.695312 0.605469 4.03367 0.605469 8.15175C0.605469 12.2698 7.66673 19.8144 8.06191 19.8144ZM8.06192 11.8812C10.1498 11.8812 11.8424 10.1886 11.8424 8.10076C11.8424 6.01289 10.1498 4.32034 8.06192 4.32034C5.97406 4.32034 4.28151 6.01289 4.28151 8.10076C4.28151 10.1886 5.97406 11.8812 8.06192 11.8812Z",
    fill: "#348BFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.605469 8.15175C0.605469 12.2698 7.66673 19.8144 8.06191 19.8144V11.8812C5.97405 11.8811 4.28151 10.1886 4.28151 8.10076C4.28151 6.0129 5.97405 4.32035 8.06191 4.32034V0.695312C3.94383 0.695312 0.605469 4.03367 0.605469 8.15175Z",
    fill: "#193861"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5032_48457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenters);
export default __webpack_public_path__ + "static/media/centers.dfd34f7e82af460f2f452651b8c13386.svg";
export { ForwardRef as ReactComponent };